export default "__VITE_ASSET__VG5N5DoN__"